import { render, staticRenderFns } from "./TeamPreview.vue?vue&type=template&id=a043af42&scoped=true&"
import script from "./TeamPreview.vue?vue&type=script&lang=js&"
export * from "./TeamPreview.vue?vue&type=script&lang=js&"
import style0 from "./TeamPreview.vue?vue&type=style&index=0&id=a043af42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a043af42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a043af42')) {
      api.createRecord('a043af42', component.options)
    } else {
      api.reload('a043af42', component.options)
    }
    module.hot.accept("./TeamPreview.vue?vue&type=template&id=a043af42&scoped=true&", function () {
      api.rerender('a043af42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/onboarding/client/selectTeam/TeamPreview.vue"
export default component.exports